<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n()
const route = useRoute()
const breadcrumbs = computed(() => {
  return route.matched.filter(r => r.name);
});
</script>

<template>
  <div class="flex">
    <router-link v-for="(item, i) in breadcrumbs" :key="item.path" :to="item.path">
      <span class="text-sm flex">
        <p :class="route.path === item.path && 'text-primary font-semibold'">
          {{ t(String(item.meta.title)) }}
        </p>
        <p v-if="i !== breadcrumbs.length - 1" class="mx-3 text-muted-foreground/40">/</p>
      </span>
    </router-link>
  </div>
</template>
